module.exports = __webpack_public_path__ + "static/img/12.5c8c8a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/21/eng/12.png
// module id = mRcL
// module chunks = 0